import { useMemo } from "react";
import type { ColorSwatch } from "./colors";
import { translateOrDefault } from "../utils/translationUtils";

export interface ColorSwatchText {
  /** A swatch's name, for its tooltip and accessible label. */
  getColorLabelText: (swatch: ColorSwatch) => string;
}

/**
 * Names the palette's swatches in the UI language. A swatch with no
 * translation (a custom one, say) keeps its own English label.
 */
export const useColorSwatchText = (
  t: (key: string) => string,
): ColorSwatchText =>
  useMemo(
    () => ({
      getColorLabelText: (swatch) =>
        translateOrDefault(
          t,
          `components.colorPicker.colors.${swatch.id}`,
          swatch.label,
        ),
    }),
    [t],
  );
